/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components';
import { breakpoint } from 'styles/globals';
import { getBodyStyle, getColor, type Theme } from 'styles/theme';
import { getIcon } from 'styles/icons';

export const Wrapper = styled.nav`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  &.hub-page {
    margin-bottom: 24px;
  }
`;

export const List = styled.ol`
  display: none;
  gap: 8px;

  @media (${breakpoint.mdMin}) {
    &.hub-page {
      display: flex;
    }
  }

  @media (${breakpoint.lgMin}) {
    display: flex;
  }

  &.tablet-and-mobile {
    display: flex;
    
    &.hub-page {
      @media(${breakpoint.mdMin}) {
        display: none;
      }
    }
      
    @media (${breakpoint.lgMin}) {
      display: none;
    }
  }
`;

const simpleArrow = css<{ theme: Theme; $isHub?: boolean }>`
  margin-top: 5px;
  margin-left: 5px;

  ${getIcon('prev-arrow')};

  @media(${breakpoint.mdMin}) {
    ${({ $isHub }) => getIcon($isHub ? 'next-arrow' : 'prev-arrow')};
    margin-top: 7px;
  }

  @media (${breakpoint.lgMin}) {
    ${getIcon('next-arrow')};
    margin-top: 7px;
    margin-right: 5px;
    margin-left: 0;
  }
`;

export const CrumbWrapper = styled.li<{ theme: Theme; $isHub: boolean }>`
  display: flex;
  gap: 8px;
  ${getBodyStyle('graphikCond', { default: 'small' }, 'semiBold')};

  .home {
   &:hover,
   &:hover > *:not(.no-hover){
      text-decoration: none;
      color: ${getColor('accentPrimary')};
  }
  }
  
  &.hub-page {
    a {
      &.home-link {
        height: 22px;
      }
    }
  }

  &:last-child:not(:only-child, .hub-page) {
    position: relative;
    margin-left: 8px;

    // adding double arrow to the last element on desktop view
    &::after {
      position: absolute;
      content: '';
      ${simpleArrow}
      color: ${getColor('neutralDarkGray')};
      left: -8px;
    }
  }

  &::before {
    content: '';
    ${simpleArrow}
    margin-top: 7px;
    color:  ${getColor('neutralDarkGray')};
    align-self: flex-start;
  }

  // hide first arrow on desktop
  &:first-child:not(:only-child)::before {
    display: none;
  }
`;

interface CrumbProps {
  $last?: boolean;
  theme: Theme;
}

export const Crumb = styled.span<CrumbProps>`
 text-transform: capitalize;
  line-height: 21px;
  letter-spacing: 0.5px;
  font-size: 16px;
  color: ${getColor('neutralBlack')};

  &.home-link {
    &::before {
      ${simpleArrow}
      margin-right: 8px;
      color:  ${getColor('neutralDarkGray')};

      @media(${breakpoint.mdMin}) {
          content: none;
      }
    }
  }

  @media(${breakpoint.mdMin}){
      font-size: 14px;
    }
  
  ${(props) =>
    !props.$last
      ? css`
        transition: all 0.25s;
        white-space: nowrap;
      `
      : css<{ theme: Theme }>`
        text-align: left;

        @media(${breakpoint.mdMin}) {
          color: ${getColor('neutralDarkGray')};;
        }
      `}
`;
